import React, { useEffect } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import Title from "../../components/Title/Title";
import "./AboutFounder.scss";

export default function AboutFounder() {
  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="founder_about" className="section section-bg py-5">
      <div className="container">
        <Row className="py-4" data-aos="fade-down" data-aos-duration="500">
          <Col xs={12} className="text-center">
            <Title
              regular_text="About the"
              highlighted_text="Founder & CEO"
            />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} className="founder-content" data-aos="fade-up" data-aos-duration="500">
            <div className="clearfix">
              <Image
                className="img-fluid founder-image float-md-end ms-md-4 mb-4 rounded-circle"
                src={require("../../assets/team/owner.png")}
                alt="George Morariu - Founder & CEO"
              />
              <h2>George Morariu</h2>
              <h5 className="text-muted mb-4">Founder & CEO</h5>
              <p>
                George Morariu founded Woodlands Digital Technologies in 2021, with the goal of helping businesses
                modernize and adopt proven digital technologies while retaining their existing values and way of
                doing business. He believes in incremental technology adoption such that the business owners and
                their customers are comfortable with the adopted technology and remain always in control. George
                believes that values like family, community, freedom of expression, financial responsibility, privacy
                or integrity must be preserved and built in all new technologies. That's why George and
                Woodlands Digital Technologies are committed to make tech accessible,
                by often offering significant discounts to projects and companies sharing these values.
              </p>
              <p>
                Before founding Woodlands Digital Technologies, George spent more than 2 decades in the digital technology
                field, most of it in the heart of Silicon Valley, in multiple executive and leadership roles like
                Chief Technology Officer, Vice President of Engineering or Director of Engineering. He provided
                leadership for a variety of companies both large and small, being part of companies like Hewlett-Packard,
                VMware, NoonHome (acquired by Savant), Memeo (acquired by Unicom Global), NXP Semiconductors or American Bureau of Shipping.
              </p>
              <p>
                Throughout his career George specialized, invented and delivered software and hardware products and solutions in areas like:
              </p>
              <ul className="list-unstyled founder-expertise-list">
                <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> Cloud Services like AWS, Azure, Google Cloud</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> Mobile Apps</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> Web Apps</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> Consumer and Enterprise Software</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> Machine Learning and Artificial Intelligence (ML/AI)</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> Internet connected hardware (IoT)</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> Data acquisition, structuring and reporting</li>
                <li><FontAwesomeIcon icon={faCircleCheck} className="text-primary me-2" /> Process automation</li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
